// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Tag-primaryButton-1ztpu7","tag":"Tag-tag-hdSpSX","fadingBackground":"Tag-fadingBackground-22C__o","clickable":"Tag-clickable-38vA38","text":"Tag-text-1Huivh"};